/**
 * api接口统一管理
 */
import { get, post, del, put, upload, imgDown } from "./reqeust";

const Api = {
  Auth: {
    // 注册
    registerUser(username, password, school) {
      let p = {
        'username': username,
        'password': password,
        'school': school,
      };
      return post("/users/register/", p);
    },
    // 登录
    login(username, password) {
      let p = {
        username: username,
        password: password,
      };
      return post("/login", p);
    },
  },
  MyCalss: {
    myClass() {
      return get("/myclass/");
    },
    createClass(p) {
      return post("/myclass/create/", p);
    },
    deleteMyClass(classid) {
      return del(`/myclass/${classid}`);
    },
    // /myclass/group/{classid}
    updateClassGroupid(classid,groupId) {
      return post(`/myclass/group/${classid}`,{'groupId':groupId});
    },
  },
  Student: {
    students(classid) {
      return get(`/student/${classid}`);
    },
    createStudent(p) {
      return post("/student/create/", p);
    },
    createStudents(p) {
      return post("/student/mutcreate/", p);
    },
    deleteStudent(studentid) {
      return del(`/student/${studentid}`);
    },
  },
  Group: {
    groups(classid) {
      return get(`/group/${classid}`);
    },
    createGroup(p) {
      return post("/group/create/", p);
    },
    deleteGroup(groupid) {
      return del(`/group/${groupid}`);
    }, 
    groupInfo(groupId) {
      return get(`/group/info/${groupId}`);
    }
  },
  Link: {
    mutLink(p) {
      return post("/groupstudent/mutlink/", p);
    },
    groupLinkStudents(groupid) {
      return get(`/groupstudent/${groupid}`);
    },
  },
};

export default Api;
